export const SETTINGS_FORM_STYLES = `
/* ── Settings Form Container ── */
.settings-form-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 600px;
}

.settings-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ── Form Sections ── */
.form-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary, #1f2937);
}

.form-hint {
  font-size: 12px;
  color: var(--text-muted, #6b7280);
  line-height: 1.4;
}

/* ── Form Inputs ── */
.form-input,
.form-select {
  padding: 10px 12px;
  border: 1px solid var(--border-color, #d1d5db);
  border-radius: 6px;
  font-size: 14px;
  color: var(--text-primary, #1f2937);
  background: var(--bg-primary, white);
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-input:focus,
.form-select:focus {
  outline: none;
  border-color: var(--blue-500, #3b82f6);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-input[type="number"] {
  font-family: monospace;
}

/* ── Radio Group ── */
.form-radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 8px 0;
}

.form-radio-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: var(--text-primary, #1f2937);
  padding: 6px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.form-radio-label:hover {
  background: var(--bg-secondary, #f9fafb);
}

.form-radio {
  width: 18px;
  height: 18px;
  cursor: pointer;
  flex-shrink: 0;
}

/* ── Checkbox ── */
.form-checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: var(--text-primary, #1f2937);
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.form-checkbox-label:hover {
  background: var(--bg-secondary, #f9fafb);
}

.form-checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
  flex-shrink: 0;
  accent-color: var(--blue-500, #3b82f6);
}

/* ── Notification Types ── */
.notification-types {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 8px;
  padding: 8px 0;
}

/* ── Actions ── */
.settings-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 16px;
  border-top: 1px solid var(--border-color, #e5e7eb);
}

.btn {
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary {
  background: var(--blue-500, #3b82f6);
  color: white;
}

.btn-primary:hover {
  background: var(--blue-600, #2563eb);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-secondary {
  background: var(--gray-200, #e5e7eb);
  color: var(--text-primary, #1f2937);
}

.btn-secondary:hover {
  background: var(--gray-300, #d1d5db);
}

.btn-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ── Settings View ── */
.settings-view {
  padding: 20px;
  background: var(--bg-primary, white);
  border-radius: 8px;
}

.settings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-color, #e5e7eb);
}

.settings-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary, #1f2937);
}

.settings-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  gap: 16px;
}

.settings-loading .spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--border-color, #e5e7eb);
  border-top-color: var(--blue-500, #3b82f6);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.settings-error {
  padding: 16px;
  background: var(--red-50, #fef2f2);
  border: 1px solid var(--red-200, #fecaca);
  border-radius: 6px;
  color: var(--red-700, #b91c1c);
  font-size: 14px;
}

.settings-success {
  padding: 16px;
  background: var(--green-50, #f0fdf4);
  border: 1px solid var(--green-200, #bbf7d0);
  border-radius: 6px;
  color: var(--green-700, #15803d);
  font-size: 14px;
  margin-bottom: 16px;
}

/* ── Responsive ── */
@media (max-width: 600px) {
  .settings-form-container {
    max-width: 100%;
  }

  .settings-actions {
    flex-direction: column-reverse;
  }

  .btn {
    width: 100%;
  }

  .notification-types {
    grid-template-columns: 1fr;
  }
}
`;
